module.exports = __webpack_public_path__ + "static/media/Woman-with-gold-mask-586432-min.c9b4df19.jpg";